import React from 'react';
import { AgFinancing } from '@indigo-ag/schema';
import { Body, LegalBody } from '@indigo-ag/component-module';
import i18next from 'core/i18n';

interface IWarrantyTypeProps {
  collateralType: AgFinancing['collateralType'];
}

export const WarrantyType: React.FunctionComponent<IWarrantyTypeProps> = ({ collateralType }) => {
  return (
    <div className="flex">
      <div className="flex align-items-center">
        <LegalBody style={{ marginRight: 8 }}>{i18next.t('warrantyType')}</LegalBody>
        <Body style={{ marginTop: 0 }}>{collateralType ? i18next.t(collateralType) : ' - '}</Body>
      </div>
    </div>
  );
};
